module.exports = __webpack_public_path__ + "img/trash-outline.bf9b97d5.svg";